const DEVICE_OS_ANDROID = 'Android';
const DEVICE_OS_IOS = 'iOS';
const DEVICE_OS_WINDOWS_PHONE = 'Windows Phone';
export function parseOS(userAgent) {
  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return DEVICE_OS_WINDOWS_PHONE;
  }

  if (/android/i.test(userAgent)) {
    return DEVICE_OS_ANDROID;
  } // iOS detection from: http://stackoverflow.com/a/9039885/177710


  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return DEVICE_OS_IOS;
  }

  return null;
}

const isIOS = userAgent => parseOS(userAgent) === DEVICE_OS_IOS;

const isAndroid = userAgent => parseOS(userAgent) === DEVICE_OS_ANDROID;

const isMobile = userAgent => {
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent);
};

export default parseOS;
export { isIOS, isAndroid, isMobile };